<template>

        <div class="slidedown">
            <div class="select">
                <span v-if="selectedItem == null">{{ selectText }}</span>
                <span v-if="selectedItem != null">{{ selectedItem[textField] }}</span>
                <!--<i class="fa fa-chevron-left"></i>-->
            </div>
            <input type="hidden" :name="name">
            <ul class="slidedown-menu">
                <li :id="item[dataField]" v-for="item of dropItems">{{ item[textField] }}</li>
            </ul>
        </div>

</template>

<script>
    import $ from 'jquery'

    export default {
        name: "slide-down",

        props: ['name', 'value', 'items', 'selectedValue', 'selectText', 'dataField', 'textField'],

        data(){
            return{
                dropDownOpen: false,
                dropItems: [],
                selectedItem: null
            }
        },

        watch:{
            items(){
                this.setItems();
            }
        },

        methods:{
            calculateSelecteditem() {
                let vm = this;

                if (this.dropItems === undefined) {
                    vm.selectedItem = null;
                } else {
                    let selected = this.dropItems.filter((item) => {
                        return item.Selected === true;
                    });
                    //console.info('calculateSelecteditem -> selected', selected);

                    vm.selectedItem = selected.length ? selected[0] : null;
                }
            },

            onSelect(item){
                let vm = this;
                for(let i = 0; i< this.dropItems.length; i++) {
                    let el = this.dropItems[i];
                    el.Selected = el[vm.dataField] === item[vm.dataField];
                    vm.$set(vm.dropItems, i, el)
                }
                this.dropDownOpen = false;
                this.calculateSelecteditem();

                this.$emit('input', item[vm.dataField]);
                this.$emit('change', item);
            },

            setItems(){
                let vm = this;
                this.dropItems = [];

                if(this.withSelectItem === 'true'){
                    let selectItem = {};
                    selectItem[vm.dataField] = '';
                    selectItem[vm.textField] = 'Выбрать';
                    this.dropItems.splice(0, 0, selectItem);
                }

                if(this.items !== undefined) {
                    for (let item of this.items) {
                        this.dropItems.push(Object.assign({}, item));
                    }

                    let selectId = vm.selectedValue || vm.value;
                    //console.info('mounted, selectId', selectId);
                    if (selectId != null) {
                        for (let i = 0; i < vm.dropItems.length; i++) {
                            let el = vm.dropItems[i];
                            if (el[vm.dataField] === selectId) {
                                //console.info('found el.Value', el.Value)
                                el.Selected = true;
                                vm.$set(vm.dropItems, i, el);
                            }
                        }
                    } else if (vm.dropItems.length) {
                        // vm.dropItems[0].Selected = true;
                        // this.$emit('input', vm.dropItems[0][vm.dataField]);
                    }

                    this.calculateSelecteditem();
                }
            }
        },

        mounted(){
            let vm = this;

            this.setItems();

            $(this.$el).on('click', function () {
                $(this).attr('tabindex', 1).focus();
                $(this).toggleClass('active');
                $(this).find('.slidedown-menu').slideToggle(300);
            });
            $(this.$el).on('focusout', function () {
                $(this).removeClass('active');
                $(this).find('.slidedown-menu').slideUp(300);
            });
            $(this.$el).on('click', '.slidedown-menu li', function () {
                let val = $(this).attr('id');
                $(this).parents('.slidedown').find('span').text($(this).text());
                $(this).parents('.slidedown').find('input').attr('value', val);


                let item = vm.dropItems.find(x => {
                    return x[vm.dataField] == val;
                });
                vm.$emit('input', val);
                vm.$emit('change', item);
            });
        },

        destroyed() {
            $(this.$el).off('click');
            $(this.$el).off('focusout');
        },

        updated(){
            if(this.value !== undefined) {
                let vm = this;
                let val = this.value;
                for (let i = 0; i < this.dropItems.length; i++) {
                    let el = this.dropItems[i];
                    el.Selected = el[vm.dataField] == val;
                }
                this.calculateSelecteditem();
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Content/src/components/SlideDown.vue